import { Middleware } from '@reduxjs/toolkit';
import { io, Socket } from 'socket.io-client';
import { getWsBaseUrl } from '../../utils/env';
import { updateAssistant } from '../slices/assistantSlice';

let socket: Socket | null = null;

export const socketMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  // Initialize socket when user becomes authenticated
  const state: any = store.getState();
  const isAuthenticated: boolean = state.auth?.isAuthenticated;
  const token: string | null = localStorage.getItem('accessToken');

  if (isAuthenticated && token && !socket) {
    socket = io(getWsBaseUrl(), {
      auth: { token },
      transports: ['polling'], // Use polling only (WebSocket upgrade fails through Traefik)
      upgrade: false, // Disable automatic upgrade to prevent console errors
    });

    socket.on('connect', () => {
      // no-op
    });

    socket.on('analytics.update', (payload: any) => {
      try {
        store.dispatch({ type: 'analytics/updateStats', payload });
      } catch {}
    });

    socket.on('callStats.update', (payload: any) => {
      try {
        store.dispatch({ type: 'callStats/update', payload });
      } catch {}
    });

    socket.on('conversation.new', (payload: any) => {
      try {
        store.dispatch({ type: 'conversations/appendConversation', payload });
      } catch {}
    });

    socket.on('assistant.status', (payload: any) => {
      try {
        store.dispatch(updateAssistant(payload));
      } catch {}
    });

    socket.on('messages.activity', (_payload: any) => {
      // In a full implementation, refetch or update message activity series
    });
  }

  return result;
};

export default socketMiddleware;


